const featureFlags = {
  ENABLE_MASTERDATA_PERMISSIONS: true,
  ENABLE_GROUPS_INVESTMENTS_PERMISSIONS: true,
  ENABLE_FUTURE_UNICORN_PERMISSIONS: true,
  ENABLE_PREMIUM_MEMBERS_PERMISSIONS: true,
  ENABLE_DEALS_PERMISSIONS: true,
  ENABLE_REFERRAL_PERMISSIONS: true,
  ENABLE_PAYMENTS_PERMISSIONS: true,
  ENABLE_FOUNDER_DOCUMENTS_PERMISSIONS: true,
  ENABLE_DOCUMENTS_PERMISSIONS: true,
  ENABLE_SETTINGS_PERMISSIONS: true,
  ENABLE_ANALYTICS_PERMISSIONS: true,
  ENABLE_SIDEBAR_PERMISSIONS: true,
};

export default featureFlags;